import { AdvantageFormatName } from "../../types";
import { createMultiMidscroll } from "./multi-midscroll-base";

export const tripleMidscroll = createMultiMidscroll(
    AdvantageFormatName.TripleMidscroll,
    "A triple fullscreen format that fixes the ad to the middle of the page as the user scrolls down.",
    3
);